export enum ActualCallType {
    INBOUND = 'inbound',
    OUTBOUND = 'outbound',
}
